<template>
	<!--購入制限付きの場合 -->
	<div v-if="ptInitData.productInfo.YOYAKU_ITEM_FLG != 1 && ptInitData.productInfo.BUY_LIMIT_FLG == 1">
		<p class="inOneOrder sort-item" v-if="ptInitData.productInfo.BUY_LIMIT_SU_MAX >= 1">
			{{ $t('pt125.labels.inOneOrder[0]') }}<strong>{{
				ptInitData.productInfo.BUY_LIMIT_SU_MAX }}</strong>{{
					$t('pt125.labels.inOneOrder[1]') }}
		</p>
		<p class="inOneOrder sort-item" v-if="ptInitData.productInfo.BUY_LIMIT_SU_MIN >= 1">
			{{ $t('pt125.labels.inOneOrder2[0]') }}<strong>{{
				ptInitData.productInfo.BUY_LIMIT_SU_MIN }}</strong>{{
					$t('pt125.labels.inOneOrder2[1]') }}
		</p>
		<p class="inOneDes sort-item" v-if="ptInitData.qtyMin > 1">
			<font color="red">※{{ ptInitData.qtyMin }}</font><span v-html="ptInitData.descriptionInfo[1]"></span>
		</p>
	</div>
</template>
<script>
export default {
		name: 'inOneOrder',
		props: {
			ptInitData: {
				type: Object,
				default: null
			}
		},
		data() {
			return {
			}
		}
	}
</script>